import sendFitmentComplaintToZendesk from '../../graphql/products/sendFitmentComplaintToZendesk'

import GraphQLRequest from 'Clutch/Utilities/GraphQLClient/GraphQLClient'

export async function sendFitmentFeedbackToZendesk(input) {
  const variables = {
    input: input,
  }

  const res = await GraphQLRequest('/graphql/products', sendFitmentComplaintToZendesk, variables)
  return res?.sendFitmentComplaintToZendesk?.success
}
